import { User, UserStatusFilter, UsersPage } from "@app/models/User";
import {
  deleteRequest,
  getRequest,
  getPageRequest,
  postRequestData,
} from "@app/services/api/api";

const USERS_PATH = "users";
const AVATARS_PATH = "avatars";
export const SEARCH_PARAM = "search";
export const DEPARTMENTS_PARAM = "departmentIds";
export const STATUS_PARAM = "status";

export const useUserService = () => {
  const fetchUsersWithPage = (
    page: number,
    size: number,
    search: string | undefined,
    departmentIds: string[] | undefined,
    status: UserStatusFilter,
  ) => {
    let url = `${USERS_PATH}?`;
    if (search) {
      url += `&${SEARCH_PARAM}=${search}`;
    }
    if (departmentIds) {
      departmentIds.forEach(
        (departmentId) => (url += `&${DEPARTMENTS_PARAM}=${departmentId}`),
      );
    }
    if (status === "all") {
      url += "&isShowingInactiveUser=true";
    }
    if (status === "bench") {
      url += "&isOnBench=true";
    }
    return getPageRequest<UsersPage>(url, page, size);
  };

  const fetchUserById = (id: string) => {
    return getRequest<User>(`${USERS_PATH}/${id}`);
  };

  const updateAvatar = (id: string, formData: FormData) => {
    return postRequestData(`${USERS_PATH}/${id}/${AVATARS_PATH}`, formData);
  };

  const deleteUserAvatar = (id: string) => {
    return deleteRequest(`${USERS_PATH}/${id}/${AVATARS_PATH}`);
  };

  return {
    fetchUsersWithPage,
    fetchUserById,
    updateAvatar,
    deleteUserAvatar,
  };
};
